module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Review"
  }, [(_vm.notification !== null) ? _c('div', [_c('div', {
    staticClass: "notification",
    class: {
      error: _vm.notification.type === 'error', success: _vm.notification.type === 'success'
    }
  }, [_c('span', {
    on: {
      "click": _vm.clearNotification
    }
  }, [_vm._v("x")]), _vm._v("\n          " + _vm._s(_vm.notification.message) + "\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "float-right lang-selector"
  }, [_c('a', {
    class: {
      active: _vm.curLang === 'FR'
    },
    on: {
      "click": function($event) {
        return _vm.changelang('FR')
      }
    }
  }, [_vm._v("🇫🇷")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.curLang === 'EN'
    },
    on: {
      "click": function($event) {
        return _vm.changelang('EN')
      }
    }
  }, [_vm._v("🇬🇧")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.curLang === 'DE'
    },
    on: {
      "click": function($event) {
        return _vm.changelang('DE')
      }
    }
  }, [_vm._v("🇩🇪")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.curLang === 'IT'
    },
    on: {
      "click": function($event) {
        return _vm.changelang('IT')
      }
    }
  }, [_vm._v("🇮🇹")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.curLang === 'ES'
    },
    on: {
      "click": function($event) {
        return _vm.changelang('ES')
      }
    }
  }, [_vm._v("🇪🇸")])]), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "questionnaire-main-header"
    }
  }, [_vm._v(_vm._s(_vm.lang.title_trade_in_summary))]), _vm._v(" "), (_vm.questionnaire !== null) ? _c('div', [_c('table', {
    attrs: {
      "aria-describedby": "questionnaire-main-header"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.title_created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.questionnaire.created_at))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.title_expires_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.questionnaire.expires_at))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.title_value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.questionnaire.reference))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.title_original_value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.questionnaire.currency_symbol) + _vm._s(_vm.questionnaire.original_value))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.title_inspected_value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.questionnaire.currency_symbol) + _vm._s(_vm.questionnaire.inspected_value))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.title_status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.questionnaire.status))])]), _vm._v(" "), (_vm.questionnaire.decided_at !== null) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.title_decision_made_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.questionnaire.decided_at))])]) : _vm._e()])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "item-breakdown-header"
    }
  }, [_vm._v(_vm._s(_vm.lang.title_item_breakdown))]), _vm._v(" "), _c('table', {
    attrs: {
      "aria-describedby": "item-breakdown-header"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "column"
    }
  }, [_vm._v(_vm._s(_vm.lang.title_item_reference))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "column"
    }
  }, [_vm._v(_vm._s(_vm.lang.title_item_name))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "column"
    }
  }, [_vm._v(_vm._s(_vm.lang.title_downgrade_reason))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "column"
    }
  }, [_vm._v(_vm._s(_vm.lang.title_quoted_grade))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "column"
    }
  }, [_vm._v(_vm._s(_vm.lang.title_current_grade))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "column"
    }
  }, [_vm._v(_vm._s(_vm.lang.title_quoted_value))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "column"
    }
  }, [_vm._v(_vm._s(_vm.lang.title_current_value))])])]), _vm._v(" "), _vm._l((_vm.questionnaire.questionnaire_items), function(questionnaire_item) {
    return _c('tbody', {
      key: questionnaire_item.item_reference
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(questionnaire_item.item_reference))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(questionnaire_item.item_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(questionnaire_item.downgrade_reason))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.lang[("grade_" + (questionnaire_item.quoted_grade))]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.lang[("grade_" + (questionnaire_item.current_grade))]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.questionnaire.currency_symbol) + _vm._s(questionnaire_item.quoted_value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.questionnaire.currency_symbol) + _vm._s(questionnaire_item.current_value))])])])
  })], 2), _vm._v(" "), (_vm.questionnaire.status == 'Awaiting Decision') ? _c('h2', [_vm._v(_vm._s(_vm.lang.title_accept_reject_offer))]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.questionnaire.status != _vm.lang.status_1) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.lang.text_decision_made))])]) : _c('div', [_c('p', [_vm._v(_vm._s(_vm.lang.text_accept_reject))]), _vm._v(" "), _c('a', {
    staticClass: "button accept",
    on: {
      "click": _vm.accept
    }
  }, [_vm._v(_vm._s(_vm.lang.button_accept))]), _vm._v(" "), _c('a', {
    staticClass: "button reject",
    on: {
      "click": _vm.reject
    }
  }, [_vm._v(_vm._s(_vm.lang.button_reject))])])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33b56cec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Review.vue
// module id = 44
// module chunks = 1